import {DeviceDetectorService, DeviceType} from 'ngx-device-detector';

import {Inject, Injectable, signal, WritableSignal} from '@angular/core';
import {DeviceOSType, MainInjector} from '@shared-types';

@Injectable({
	providedIn: 'root',
})
export class DeviceService {
	public readonly deviceType: WritableSignal<DeviceType> = signal(DeviceType.Unknown);
	public isMobile: WritableSignal<boolean> = signal(undefined);
	public isTablet: WritableSignal<boolean> = signal(undefined);
	public isDesktop: WritableSignal<boolean> = signal(undefined);

	public landscape: WritableSignal<boolean> = signal(undefined);
	public portrait: WritableSignal<boolean> = signal(undefined);

	public deviceOS: WritableSignal<DeviceOSType> = signal(undefined);

	/* -------------------------------------------------------------------------------------------------------------- */
	constructor(@Inject(DeviceDetectorService) private deviceDetector: DeviceDetectorService) {
		this.sync();

		// listen to the orientation change event
		window.addEventListener('orientationchange', () => {
			this.landscape.set(this.deviceDetector.orientation === 'landscape');
			this.portrait.set(this.deviceDetector.orientation === 'portrait');
		});

		// listen to the resize event
		window.addEventListener('resize', () => {
			this.sync();
		});
	}

	sync(): void {
		this.deviceType.set(this.deviceDetector.deviceType as DeviceType);

		this.isMobile.set(this.deviceDetector.isMobile());
		this.isTablet.set(this.deviceDetector.isTablet());
		this.isDesktop.set(this.deviceDetector.isDesktop());

		this.landscape.set(this.deviceDetector.orientation === 'landscape');
		this.portrait.set(this.deviceDetector.orientation === 'portrait');
		this.deviceOS.set(this.deviceDetector.getDeviceInfo().os.toLowerCase());

		// set the body class for the device type
		document.body.classList.add(this.deviceType());
	}

	/* ---------------- Browser Info ---------------- */
	static currentBrowser() {
		return getDeviceService().deviceDetector.browser;
	}
}

export function getDeviceService(): DeviceService {
	return MainInjector.get(DeviceService);
}
